module.exports = require("domurl");


//////////////////
// WEBPACK FOOTER
// external "domurl"
// module id = 55
// module chunks = 0 1